export default __webpack_public_path__ + "static/media/shopify.4a7646dc.png";